const choo = require('choo');
const download = require('./ui/download');
const body = require('./ui/body');
const oauthRoute = require('./ui/oauthRoute');
const loginRoute = require('./ui/loginRoute');

module.exports = function(app = choo({ hash: true })) {
  app.route('/', body(require('./ui/home')));
  app.route('/download/:id', body(download));
  app.route('/download/:id/:key', body(download));
  app.route('/unsupported/:reason', body(require('./ui/unsupported')));
  app.route('/error', body(require('./ui/error')));
  app.route('/blank', body(require('./ui/blank')));
  app.route('/oauth', body(oauthRoute));
  app.route('/login', body(loginRoute));
  app.route('/report', body(require('./ui/report')));
  app.route('*', body(require('./ui/notFound')));
  return app;
};
